import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class accountPersonGraphql extends GraphQlService {
  async getAccountPersonByAccountId(accountId) {
    return this.client
      .query({
        query: gql`
            query {
                getAccountPersonByAccountId (
                id: "${accountId}"
              ){
                accountId
                organizationName
                organization {
                  id
                }
              }
            }
          `,
      })
      .then((result) => result?.data?.getAccountPersonByAccountId);
  }

  async updateOnlineStatus(isOnline) {
    return this.client
      .mutate({
        mutation: gql`
          mutation  {
            updateOnlineStatus(
              updateOnlineStatusInput: { isOnline: ${isOnline} }
            ) 
          }
        `,
        variables: {
          isOnline,
        },
      })
      .then((result) => result?.data?.updateOnlineStatus);
  }

  async updateGender(gender) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            updateGender(updateGenderInput:{
              gender: "${gender}"
            }){
              id
            }  
          }
          `,
      })
      .then((result) => result?.data?.updateGender);
  }
  async getAttributesWithStudentByAccountId(accountId) {
    return this.client
      .query({
        query: gql`
              query {
                getAttributesWithStudentByAccountId(accountId:"${accountId}"){
                  attributeName
                  attributeValue
                  studentCount
                  studentIds
                }
              }
            `,
      })
      .then((result) => result?.data?.getAttributesWithStudentByAccountId);
  }

  async getAttributesValuesByAccountId(accountId) {
    return this.client
      .query({
        query: gql`
            query {
              getAttributesValuesByAccountId(accountId:"${accountId}"){
                attributeName
                attributeValue
                studentCount
              }
            }
          `,
      })
      .then((result) => result?.data?.getAttributesValuesByAccountId);
  }

  async updateColor(data) {
    return this.client
      .mutate({
        mutation: gql`
            mutation {
              updateColor(updateColorInput:  {
                  id: "${data.id}"
                  color: ${data.color ? `"${data.color}"` : null}
                }) {
                id
                color
              }
            }
          `,
      })
      .then((result) => result?.data?.updateColor);
  }

  async getAttributeByAccountIdAndOrganizationId(accountId, organizationId) {
    return this.client
      .query({
        query: gql`
            query {
              getAttributeByAccountIdAndOrganizationId(
                accountId: "${accountId}",
                organizationId: "${organizationId}"
              ) {
                id
                accountId
                organizationId
                name
              }
            }
          `,
      })
      .then((result) => result?.data?.getAttributeByAccountIdAndOrganizationId);
  }

  async getOrganizationFilterOptions() {
    return this.client
      .query({
        query: gql`
          query {
            getOrganizationFilterOptions {
              accountId
              organizationName
            }
          }
        `,
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getOrganizationFilterOptions);
  }

  async getFilteredProfileIds(filters) {
    return this.client
      .query({
        query: gql`
          query GetFilteredProfileIds($filters: [ProfileFilterInput!]) {
            getFilteredProfileIds(filters: $filters) {
              userId
              accountId
            }
          }
        `,
        variables: {
          filters: filters?.length
            ? filters.map((filter) => ({
                key: filter.key,
                isEqual: !!filter.isEqual,
                value: `${filter.value}`,
              }))
            : null,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) =>
        // Apollo's InMemoryCache tags every response object with `__typename`
        // even though the query above never asks for it. Callers pass this
        // array straight through as the `pairs` input to other GraphQL
        // queries, whose input-type coercion is strict and rejects any
        // unrecognized field — so the stray `__typename` must be stripped
        // here, at the source, rather than in every consumer.
        result?.data?.getFilteredProfileIds?.map(({ userId, accountId }) => ({
          userId,
          accountId,
        }))
      );
  }

  async getStatisticsAttributeFilterOptions() {
    return this.client
      .query({
        query: gql`
          query {
            getStatisticsAttributeFilterOptions {
              key
              values
            }
          }
        `,
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getStatisticsAttributeFilterOptions);
  }

  async getFilteredStatisticsUserIds(filters) {
    return this.client
      .query({
        query: gql`
          query GetFilteredStatisticsUserIds($filters: [ProfileFilterInput!]) {
            getFilteredStatisticsUserIds(filters: $filters) {
              userId
              accountId
            }
          }
        `,
        variables: {
          filters: filters?.length
            ? filters.map((filter) => ({
                key: filter.key,
                isEqual: !!filter.isEqual,
                value: `${filter.value}`,
              }))
            : null,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) =>
        // Same `__typename` stripping as getFilteredProfileIds above — this
        // array is forwarded as-is into other queries' `pairs` input, whose
        // strict GraphQL input coercion rejects any unrecognized field.
        result?.data?.getFilteredStatisticsUserIds?.map(
          ({ userId, accountId }) => ({ userId, accountId })
        )
      );
  }

  async getByAccountIdAndUserId(accountId, userId) {
    return this.client
      .query({
        query: gql`
            query {
              getAccountPersonByAccountIdAndUserId(
                accountId: "${accountId}",
                userId: "${userId}"
              ) {
                id
                accountId
              }
            }
          `,
      })
      .then((result) => result?.data?.getAccountPersonByAccountIdAndUserId);
  }
}
const accountPersonService = new accountPersonGraphql();
export default accountPersonService;
